import React from 'react';
import { Toolbar, Typography, Tooltip, IconButton, Icon, CircularProgress } from "@material-ui/core";
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles, fade } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import PropTypes from 'prop-types';

const styles = theme => ({
		parent: {
			minWidth: 300
		},
		root: {
			flexGrow: 1,
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
		title: {
			flexGrow: 1,
			display: 'none',
			[theme.breakpoints.up('sm')]: {
			display: 'block',
			},
		},
		search: {
			position: 'relative',
			borderRadius: theme.shape.borderRadius,
			backgroundColor: fade(theme.palette.common.black, 0.15),
			'&:hover': {
			backgroundColor: fade(theme.palette.common.black, 0.25),
			},
			marginLeft: 0,
			width: '100%',
			[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(1),
			width: 'auto',
			},
		},
		searchIcon: {
			width: theme.spacing(7),
			height: '100%',
			position: 'absolute',
			pointerEvents: 'none',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			color: "black"
		},
		inputRoot: {
			color: 'inherit',
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 7),
			transition: theme.transitions.create('width'),
			width: '100%',
			[theme.breakpoints.up('sm')]: {
			width: 120,
			'&:focus': {
				width: 200,
			},
			},
		},
		buttonProgress: {
			color: green[500],
			position: 'absolute',
			top: '50%',
			right: '18%',
			marginTop: -14,
			marginLeft: -12,
		},
		wrapper: {
			margin: theme.spacing(1),
			position: 'relative',
		  },
	});

const EnhancedTableToolbar = props => {

	const classes = props.classes;

	const {exportReport, title, subtitle, refresh, onSearchTextChange, showProgress, loading, searchText} = props

	return (
		<Toolbar >
		<div classes={classes.parent}>
			{ title &&
				<Typography variant="h6" id="tableTitle" style={{minWidth: 200}}>
					{title} {subtitle ? subtitle : ""}
				</Typography>
			}
		</div>
		<div style={{flex: '1 2 100%'}} />
		{	onSearchTextChange &&
			<div className={classes.search}>
				<div className={classes.searchIcon}>
					<SearchIcon />
				</div>
				<InputBase
					placeholder="Search…"
					classes={{
						root: classes.inputRoot,
						input: classes.inputInput,
					}}
					inputProps={{ 'aria-label': 'search' }}
					onChange={(e) => onSearchTextChange(e)}
					value={searchText ? searchText : ""}
					/>
			</div>
		}
		{	exportReport &&
			<div style={{color: 'red'}} className={classes.wrapper}>
				<Tooltip title="Export">
					<IconButton aria-label="export" onClick={exportReport} disabled={loading}>
						<Icon>save_alt</Icon>
					</IconButton>
				</Tooltip>
				{showProgress && loading && <CircularProgress size={30} className={classes.buttonProgress} />}
			</div>
		}
		{
			refresh &&
			<div style={{color: 'red'}}>
				<Tooltip title="Refresh">
					<IconButton aria-label="refresh" onClick={refresh}>
						<Icon>refresh</Icon>
					</IconButton>
				</Tooltip>
			</div>
		}
		</Toolbar>
	);
};

EnhancedTableToolbar.propTypes = {
	exportReport: PropTypes.func, 
	title: PropTypes.any, 
	subtitle: PropTypes.string, 
	refresh: PropTypes.func, 
	onSearchTextChange: PropTypes.func, 
	searchText: PropTypes.string,
	showProgress: PropTypes.bool, 
	loading: PropTypes.bool
};

export default withStyles(styles)(EnhancedTableToolbar);